import React from "react";
import {FormGroup} from "@unibuddy/patron";
import * as yup from "yup";
import {useTranslation} from "@unibuddy/intl";

import DegreeLevelSelect from "shared/Register/components/DegreeLevelSelect/DegreeLevelSelect";
import {useUniversity} from "../../../UniversityProvider/UniversityProvider";
import {IntlNamespaces} from "../../../../../translations/types";
import {INTL_DEGREE_LEVEL_INTEREST, INTL_SELECT_LEVEL} from "../../../../../translations/signup";
import {INTL_DEGREE_LEVEL_REQUIRED} from "../../../../../translations/validations";

export function DegreeLevelsFormField() {
    const {t} = useTranslation([IntlNamespaces.VALIDATIONS, IntlNamespaces.SIGNUP]);
    const {slug, features} = useUniversity();

    const customLevelsEnabled = features.get("customLevelsEnabled");

    if (!customLevelsEnabled) return null;

    return (
        <FormGroup
            initialValue=""
            validation={yup
                .string()
                .required(
                    t(
                        `${IntlNamespaces.VALIDATIONS}:${INTL_DEGREE_LEVEL_REQUIRED.key}`,
                        INTL_DEGREE_LEVEL_REQUIRED.defaultValue,
                    ),
                )}
            label={t(
                `${IntlNamespaces.SIGNUP}:${INTL_DEGREE_LEVEL_INTEREST.key}`,
                INTL_DEGREE_LEVEL_INTEREST.defaultValue,
            )}
            id="degree-level"
        >
            <DegreeLevelSelect
                universitySlug={slug}
                name="degreeLevel"
                required
                placeholder={t(
                    `${IntlNamespaces.SIGNUP}:${INTL_SELECT_LEVEL.key}`,
                    INTL_SELECT_LEVEL.defaultValue,
                )}
            />
        </FormGroup>
    );
}
